import React, { Component } from "react";

import {
  CButton,
  CCol,
  CCollapse,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSelect,
  CSpinner,
  CSwitch
} from "@coreui/react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import Breadcrumb from "../../components/Breadcrumb";
import InfiniteSelector from "../../components/InfiniteSelector";
import ProtectedRoute from "../../components/ProtectedRoute";
import DataTable from "../../components/Tables/tables";
import URL from "../../config/api";
import axios from "../../config/axios";

class Logs extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const day = today.getDay();

    const first = new Date(today.valueOf() - day * 86400000);
    const last = new Date(first.valueOf() + 6 * 86400000);

    const firstDay = `00${first.getDate()}`.slice(-2);
    const firstMonth = `00${first.getMonth() + 1}`.slice(-2);
    const firstYear = first.getFullYear();

    const lastDay = `00${last.getDate()}`.slice(-2);
    const lastMonth = `00${last.getMonth() + 1}`.slice(-2);
    const lastYear = last.getFullYear();

    const todayDay = `00${today.getDate()}`.slice(-2);
    const todayMonth = `00${today.getMonth() + 1}`.slice(-2);
    const todayYear = today.getFullYear();

    this.state = {
      loading: true,
      loadingFilters: false,
      logs: [],
      modalFilter: false,
      modalDetails: false,
      modalDetailsContent: null,
      action: [],
      user: null,
      origin: [],
      current_page: 1,
      per_page: 10,
      total_items: 0,
      from: `${todayYear}-${todayMonth}-${todayDay}T00:00:00`,
      to: `${todayYear}-${todayMonth}-${todayDay}T23:59:59`,
      origins: [],
      actions: [],
      mine: true,
      // users: [{ value: null, label: "Carregando" }],
      groups: [{ value: null, label: "Carregando" }],
      group: null,
      regions: [{ value: null, label: "Carregando" }],
      region: null,
      schools: [{ value: null, label: "Carregando" }],
      school: null,
      rooms: [{ value: null, label: "Carregando" }],
      room: null,
      logDownload: null
    };
    this.handleUserSelected = this.handleUserSelected.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.getFilters();
    this.handleLogs();
  }

  changeOrigin(newOriginIdArray) {
    this.setState({ origin: newOriginIdArray });
  }

  changeAction(newActionIdArray) {
    this.setState({ action: newActionIdArray });
  }

  async getFilters() {
    // Puxar a lista de todas as ações da plataforma
    const respAction = await axios
      .get(`${URL.api}audict/action/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .catch();
    // Puxa a lista de todas as possíveis origens da platforma
    const respOrigin = await axios
      .get(`${URL.api}audict/origin/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .catch();
    // Puxa a lista de todos os usuários da plataforma (PROBLEMA)
    // const respUser = await this.batchLoad(`${URL.api}access/user/list`);
    let respUser = []; // {value: user.id, label: user.name}

    // Informações de Grupo, Região, Escola e Turma do usuário logado
    let currentGroup = 0;
    let currentRegion = 0;
    let currentSchool = 0;
    let currentRoom = 0;

    // Listas com os Grupos, Regiões, Escolas e Turmas disponíveis para o usuário logado
    let currentGroups = [];
    let currentRegions = [];
    let currentSchools = [];
    let currentRooms = [];

    // Se for um usuário que possui um grupo(group_id) vinculado a ele
    if (this.props.general.active_roles.group_id) {
      // Só irá aparecer um grupo, o vinculado a ele
      currentGroups = [
        {
          value: this.props.general.active_roles.group_id,
          label: this.props.general.active_roles.group_name
        }
      ];
      currentGroup = this.props.general.active_roles.group_id;
      this.setState({ groups: currentGroups, group: currentGroup });
    }
    // Se for um adm Educandus, group_id == null
    else {
      // Pega a lista de todos os Grupos
      const res = await axios
        .get(`${URL.api}access/group/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .catch();
      const allGroups = res.data.data.map(group => ({
        value: group.id,
        label: group.name
      }));

      currentGroups = allGroups;
      currentGroup = allGroups[0].value;
      this.setState({ groups: currentGroups, group: currentGroup });
    }

    // Se for um usuário que possui uma região(region_id) vinculada a ele
    if (this.props.general.active_roles.region_id) {
      // Só irá aparecer uma região, a vinculada a ele
      currentRegions = [
        {
          value: this.props.general.active_roles.region_id,
          label: this.props.general.active_roles.region_name
        }
      ];
      currentRegion = this.props.general.active_roles.region_id;
      this.setState({ regions: currentRegions, region: currentRegion });
    }
    // Se não tiver region_id e tiver group_id, logo é um Adm de Grupo
    else if (currentGroup) {
      // Pega as Regiões do grupo específico(currentGroup) do usuário
      const res = await axios
        .get(`${URL.api}access/region/listRegionFilter/${currentGroup}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .catch();

      currentRegions = [
        { value: 0, label: "Todas" },
        ...res.data.data.map(region => ({
          value: region.id,
          label: region.name
        }))
      ];
      currentRegion = 0;
      this.setState({ regions: currentRegions, region: currentRegion });
    }
    // Se for um adm Educandus, region_id == null && group_id == null
    else {
      currentRegions = [{ value: 0, label: "Todas" }];
      currentRegion = 0;
      this.setState({ regions: currentRegions, region: currentRegion });
    }

    // Se for um usuário que possui uma escola(school_id) vinculada a ele
    if (this.props.general.active_roles.school_id) {
      currentSchools = [
        {
          value: this.props.general.active_roles.school_id,
          label: this.props.general.active_roles.school_name
        }
      ];
      currentSchool = this.props.general.active_roles.school_id;
      this.setState({ schools: currentSchools, school: currentSchool });
    }
    // Se não tiver school_id e tiver region_id, logo é um Adm Regional
    else if (currentRegion) {
      // Pega as Escolas da região específica(currentRegion) do usuário
      const res = await axios
        .get(
          `${URL.api}access/school/listSchoolFilter/${currentGroup}/${currentRegion}`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        )
        .catch();

      currentSchools = [
        { value: 0, label: "Todas" },
        ...res.data.data.map(school => ({
          value: school.id,
          label: school.name
        }))
      ];
      currentSchool = 0;
      this.setState({ schools: currentSchools, school: currentSchool });
    }
    // Se for um adm Educandus, region_id == null && group_id == null && school_id == null
    else {
      currentSchools = [{ value: 0, label: "Todas" }];
      currentSchool = 0;
      this.setState({ schools: currentSchools, school: currentSchool });
    }

    if (currentSchool) {
      const res = await axios
        .get(
          `${URL.api}community/room/list?group[]=${currentGroup}&region[]=${currentRegion}&school[]=${currentSchool}&class=true`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        )
        .catch();

      currentRooms = [
        { value: 0, label: "Todas" },
        ...res.data.data.map(room => ({ value: room.id, label: room.name }))
      ];
      currentRoom = 0;
      this.setState({ rooms: currentRooms, room: currentRoom });
    } else {
      currentRooms = [{ value: 0, label: "Todas" }];
      currentRoom = 0;
      this.setState({ rooms: currentRooms, room: currentRoom });
    }

    this.setState({
      origins: respOrigin.data.data,
      actions: respAction.data.data
      // users: [{ value: null, label: "Selecionar" }, ...respUser]
    });
  }

  handleUserSelected(user) {
    this.setState({ user: user.id });
  }

  async handleLogs() {
    this.setState({ loading: true, modalFilter: false }); // problema aqui em loading

    let query = "audict/log/list";

    query += `?from=${this.state.from}&to=${this.state.to}`;

    if (this.state.origin.length) {
      query += `&origin_id[]=${this.state.origin.join("&origin_id[]=")}`;
    }

    if (this.state.action.length) {
      query += `&action_id[]=${this.state.action.join("&action_id[]=")}`;
    }

    if (this.state.mine) {
      query += `&user_id=${this.props.user.user.id}`;
    } else {
      if (this.state.group) {
        query += `&group_id=${this.state.group}`;
      }

      if (this.state.region) {
        query += `&region_id=${this.state.region}`;
      }

      if (this.state.school) {
        query += `&school_id=${this.state.school}`;
      }

      if (this.state.room) {
        query += `&room_id=${this.state.room}`;
      }

      if (this.state.user) {
        query += `&user_id=${this.state.user}`;
      }
    }
    // query += `&page=${this.state.current_page}`;
    // query += `&offset=${this.state.per_page}`;
    const resp = await axios.get(`${URL.api}${query}`, {
      headers: {
        authorization: `Bearer ${this.props.user.token}`
      },
      params: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        offset: this.state.per_page,
        // eslint-disable-next-line react/no-access-state-in-setstate
        page: this.state.current_page
      }
    });

    this.setState({
      loading: false,
      logs: resp.data.data,
      total_items: resp.data.meta.total,
      logDownload: query
    });
  }

  async changeGroup(newGroupId) {
    this.setState({
      group: newGroupId,
      regions: [{ value: null, label: "Carregando" }],
      region: null,
      schools: [{ value: null, label: "Carregando" }],
      school: null,
      rooms: [{ value: null, label: "Carregando" }],
      room: null,
      // users: [{ value: null, label: "Carregando" }],
      user: null
    });

    const res = await axios
      .get(`${URL.api}access/region/listRegionFilter/${newGroupId}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .catch();

    this.setState({
      region: 0,
      regions: [
        { value: 0, label: "Todas" },
        ...res.data.data.map(region => ({
          value: region.id,
          label: region.name
        }))
      ],
      school: 0,
      schools: [{ value: 0, label: "Todas" }],
      room: 0,
      rooms: [{ value: 0, label: "Todas" }],
      user: 0
      // users: [{ value: 0, label: "Todos" }]
    });
  }

  async changeRegion(newRegionId) {
    this.setState({
      region: newRegionId,
      schools: [{ value: null, label: "Carregando" }],
      school: null,
      rooms: [{ value: null, label: "Carregando" }],
      room: null,
      // users: [{ value: null, label: "Carregando" }],
      user: null,
      isRoomChange: false
    });

    const res = await axios
      .get(
        // eslint-disable-next-line react/no-access-state-in-setstate
        `${URL.api}access/school/listSchoolFilter/${this.state.group}/${newRegionId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .catch();

    this.setState({
      school: 0,
      schools: [
        { value: 0, label: "Todas" },
        ...res.data.data.map(school => ({
          value: school.id,
          label: school.name
        }))
      ],
      room: 0,
      rooms: [{ value: 0, label: "Todas" }],
      user: 0
      // users: [{ value: 0, label: "Todos" }]
    });
  }

  async changeSchool(newSchoolId) {
    this.setState({
      school: newSchoolId,
      rooms: [{ value: null, label: "Carregando" }],
      room: null,
      // users: [{ value: null, label: "Carregando" }],
      user: null,
      isRoomChange: false
    });

    const res = await axios
      .get(
        // eslint-disable-next-line react/no-access-state-in-setstate
        `${URL.api}community/room/list?group[]=${this.state.group}&region[]=${this.state.region}&school[]=${newSchoolId}&class=true`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .catch();

    this.setState({
      room: 0,
      rooms: [
        { value: 0, label: "Todas" },
        ...res.data.data.map(room => ({ value: room.id, label: room.name }))
      ],
      user: 0
      // users: [{ value: 0, label: "Todos" }]
    });
  }

  async changeRoom(newRoomId) {
    this.setState({
      room: newRoomId,
      user: 0,
      // users: [{ value: 0, label: "Todos" }],
      isRoomChange: true
    });
  }

  async promiseOptions(inputValue) {
    const users = (
      await axios
        .get(`${URL.api}access/user/searchUsers`, {
          params: {
            group_id: this.state.group,
            region_id: this.state.region,
            school_id: this.state.school,
            room_id: this.state.room,
            search: inputValue
          },
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .catch()
    ).data.data.map(item => ({ value: item.id, label: item.name }));

    // this.setState({ users: [{ value: 0, label: "Todos" }, ...users] });

    return [{ value: 0, label: "Todos" }, ...users];
  }

  async userSelectorUpdate(items) {
    // this.setState({ users: items });
  }

  render() {
    return (
      <>
        <div className="animated fadeIn">
          <CRow>
            <Breadcrumb current={this.props.currentRoute} />

            {!this.state.loading ? (
              <div id="list">
                <DataTable
                  downloadRoute={this.state.logDownload}
                  list={this.state.logs}
                  title="Logs"
                  subtitle="Visualize os logs registrados na plataforma."
                  action
                  btnView
                  noSort
                  pushState={this.state}
                  remote
                  currentPage={this.state.current_page}
                  totalItems={this.state.total_items}
                  perPage={this.state.per_page}
                  customView={details =>
                    this.setState({
                      modalDetails: true,
                      modalDetailsContent: details
                    })
                  }
                  onPageChange={page =>
                    this.setState({ current_page: page }, () =>
                      // Será realmente necessário? (IMPORTANTE)
                      this.handleLogs()
                    )
                  }
                  onSizePerPageList={size =>
                    this.setState({ per_page: size }, () => this.handleLogs())
                  }
                  header={[
                    { name: "id", denomination: "ID", width: "70px" },
                    {
                      name: "user_name",
                      denomination: "Usuário",
                      width: "13%"
                    },
                    { name: "date", denomination: "Data", width: "13%" },
                    {
                      name: "origin_name",
                      denomination: "Origem",
                      width: "13%"
                    },
                    { name: "action_name", denomination: "Ação", width: "13%" },
                    { name: "old_values", denomination: "Valor anterior" },
                    { name: "new_values", denomination: "Valor Novo" }
                  ]}
                  extraComponent={
                    <CButton
                      color="primary"
                      className="ml-2"
                      onClick={() => this.setState({ modalFilter: true })}
                    >
                      <i className="fa fa-filter mr-2"></i>Filtrar
                    </CButton>
                  }
                />
              </div>
            ) : (
              <div className="w-100 d-flex justify-content-center">
                <CSpinner size="sm" color="secondary" />
              </div>
            )}
          </CRow>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </div>
        <CModal
          show={this.state.modalDetails}
          onClose={() => this.setState({ modalDetails: false })}
          size="lg"
          centered
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle className="mb-0">Detalhes do Log</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CLabel>
              <b>ID:</b> {this.state.modalDetailsContent?.id}
            </CLabel>
            <br />
            <CLabel>
              <b>Usuário:</b> {this.state.modalDetailsContent?.user_name}
            </CLabel>
            <br />
            <CLabel>
              <b>Data:</b> {this.state.modalDetailsContent?.date}
            </CLabel>
            <br />
            <CLabel>
              <b>Origem:</b> {this.state.modalDetailsContent?.origin_name}
            </CLabel>
            <br />
            <CLabel>
              <b>Ação:</b> {this.state.modalDetailsContent?.action_name}
            </CLabel>
            {this.state.modalDetailsContent?.old_values && (
              <>
                <br />
                <CLabel>
                  <b>Valor anterior:</b>{" "}
                  {this.state.modalDetailsContent?.old_values}
                </CLabel>
              </>
            )}
            {this.state.modalDetailsContent?.new_values && (
              <>
                <br />
                <CLabel>
                  <b>Valor novo:</b>{" "}
                  {this.state.modalDetailsContent?.new_values}
                </CLabel>
              </>
            )}
          </CModalBody>
        </CModal>
        <CModal
          show={this.state.modalFilter}
          onClose={() => this.setState({ modalFilter: false })}
          size="lg"
          centered
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle className="mb-0">Filtrar logs</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {this.state.loadingFilters ? (
              <div className="w-100 d-flex justify-content-center">
                <CSpinner size="sm" color="secondary" />
              </div>
            ) : (
              <>
                <CFormGroup>
                  <CLabel>Ação</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      isMulti
                      isSearchable
                      placeholder="Escolha uma Ação"
                      name="Ação"
                      options={this.state.actions.map(item => ({
                        value: item.id,
                        label: item.name
                      }))}
                      defaultValue={this.state.actions.find(
                        option => option.value === this.state.action
                      )}
                      classNamePrefix="select"
                      onChange={e =>
                        this.changeAction(e.map(action => action.value))
                      }
                    />
                  </CInputGroup>
                </CFormGroup>
                <CFormGroup>
                  <CLabel>Origem</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      isMulti
                      isSearchable
                      placeholder="Escolha uma Origem"
                      name="Origem"
                      options={this.state.origins.map(item => ({
                        value: item.id,
                        label: item.name
                      }))}
                      defaultValue={this.state.origins.find(
                        option => option.value === this.state.origin
                      )}
                      classNamePrefix="select"
                      onChange={e =>
                        this.changeOrigin(e.map(origin => origin.value))
                      }
                    />
                  </CInputGroup>
                </CFormGroup>
                <CFormGroup>
                  <CRow>
                    <CCol>
                      <div className="mb-2">Início</div>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-clock-o"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <Form.Control
                          type="datetime-local"
                          value={this.state.from}
                          step="1"
                          onChange={e =>
                            this.setState({ from: e.target.value })
                          }
                        />
                      </CInputGroup>
                    </CCol>
                    <CCol>
                      <div className="mb-2">Fim</div>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-clock-o"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <Form.Control
                          type="datetime-local"
                          value={this.state.to}
                          step="1"
                          onChange={e => this.setState({ to: e.target.value })}
                        />
                      </CInputGroup>
                    </CCol>
                  </CRow>
                </CFormGroup>
                {this.props.general.active_roles.role_name !== "Professor" && (
                  <CFormGroup>
                    <CLabel>Apenas meus logs</CLabel>
                    <CInputGroup>
                      <CSwitch
                        shape="pill"
                        color="primary"
                        size="sm"
                        checked={this.state.mine}
                        onChange={e =>
                          this.setState({ mine: e.target.checked })
                        }
                      />
                    </CInputGroup>
                  </CFormGroup>
                )}
                <CCollapse show={!this.state.mine}>
                  <CFormGroup>
                    <CRow>
                      <CCol>
                        <div className="mb-2">Grupo</div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-text-width"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <Select
                            isSearchable
                            placeholder="Escolha um grupo"
                            name="Grupo"
                            options={this.state.groups}
                            defaultValue={this.state.groups.find(
                              option => option.value === this.state.group
                            )}
                            value={this.state.groups.find(
                              option => option.value === this.state.group
                            )}
                            classNamePrefix="select"
                            onChange={e => this.changeGroup(e.value)}
                          />
                        </CInputGroup>
                      </CCol>
                      <CCol>
                        <div className="mb-2">Região</div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-text-width"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <Select
                            isSearchable
                            placeholder="Escolha uma região"
                            name="Região"
                            options={this.state.regions}
                            defaultValue={this.state.regions.find(
                              option => option.value === this.state.region
                            )}
                            value={this.state.regions.find(
                              option => option.value === this.state.region
                            )}
                            classNamePrefix="select"
                            onChange={e => this.changeRegion(e.value)}
                          />
                        </CInputGroup>
                      </CCol>
                    </CRow>
                  </CFormGroup>
                  <CFormGroup>
                    <CRow>
                      <CCol>
                        <div className="mb-2">Escola</div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-text-width"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <Select
                            isSearchable
                            placeholder="Escolha uma escola"
                            name="Escola"
                            options={this.state.schools}
                            defaultValue={this.state.schools.find(
                              option => option.value === this.state.school
                            )}
                            value={this.state.schools.find(
                              option => option.value === this.state.school
                            )}
                            classNamePrefix="select"
                            onChange={e => this.changeSchool(e.value)}
                          />
                        </CInputGroup>
                      </CCol>
                      <CCol>
                        <div className="mb-2">Turma</div>
                        <CInputGroup>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-text-width"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <Select
                            isSearchable
                            placeholder="Escolha uma turma"
                            name="Turma"
                            options={this.state.rooms}
                            defaultValue={this.state.rooms.find(
                              option => option.value === this.state.room
                            )}
                            value={this.state.rooms.find(
                              option => option.value === this.state.room
                            )}
                            classNamePrefix="select"
                            onChange={e => this.changeRoom(e.value)}
                          />
                        </CInputGroup>
                      </CCol>
                    </CRow>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Usuário</CLabel>
                    {/* <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend> */}
                    <InfiniteSelector
                      flag={this.state.isRoomChange}
                      group={this.state.group}
                      region={this.state.region}
                      school={this.state.school}
                      room={this.state.room}
                      userSelectorUpdate={this.userSelectorUpdate}
                      handleUserSelected={this.handleUserSelected}
                      disabled={!this.state.isRoomChange}
                      // multiSelect
                    />
                    {/* <AsyncSelect
                        isSearchable
                        cacheOptions
                        defaultOptions={[{ value: 0, label: "Todos" }]}
                        loadOptions={e => this.promiseOptions(e)}
                        defaultValue={this.state.users.find(
                          option => option.value === this.state.user
                        )}
                        value={this.state.users.find(
                          option => option.value === this.state.user
                        )}
                        placeholder="Escolha um usuário"
                        name="Usuário"
                        classNamePrefix="select"
                        onChange={e => this.setState({ user: e.value })}
                        loadingMessage={() => "Carregando..."}
                        noOptionsMessage={() => "Nenhum resultado"}
                      />
                    </CInputGroup> */}
                  </CFormGroup>
                </CCollapse>
              </>
            )}
          </CModalBody>
          <CModalFooter>
            <CButton color="primary" onClick={() => this.handleLogs()}>
              Filtrar
            </CButton>
          </CModalFooter>
        </CModal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Logs);
